import { useTheme } from "../ThemeProvider";
import BotonesVisorUbicacion from "./BotonesVisorUbicacion";
import MultiSelectAuxVistas from "../MultiSelectAuxVistas";
import { normalizeVistasIdsFromExtras, buildVistasExtrasPatch } from "../../config/auxCamposPipeline";
import usePermiso from "../../hooks/usePermiso";
import { usePropiedadUi } from "../../hooks/usePropiedadUi";

export default function SeccionUbicacion(props) {
  const { form, cambiar, cambiarDirecto, cambiarVarios, auxiliares, visorAddressContext } = props;
  const { tv } = usePropiedadUi(props);
  const { theme } = useTheme();
  const c = theme.colors;
  const isDark = theme.name === "dark";
  const { puede } = usePermiso();
  const puedeVerPrimeraLineaPlaya = puede("primera_linea_playa", "ver");
  const puedeModificarPrimeraLineaPlaya = puede("primera_linea_playa", "modificar");
  const puedeVerDistanciaMar = puede("distancia_mar", "ver");
  const puedeModificarDistanciaMar = puede("distancia_mar", "modificar");
  const puedeVerUbiAfectaciones = puede("ubi_afectaciones", "ver");
  const puedeModificarUbiAfectaciones = puede("ubi_afectaciones", "modificar");
  const puedeVerUbiVistas = puede("ubi_vistas", "ver");
  const puedeModificarUbiVistas = puede("ubi_vistas", "modificar");

  const vistas = auxiliares["vistas"] || [];

  const handleLinea = (name) => {
    if (!puedeModificarPrimeraLineaPlaya) return;
    const otro = name === "ub_primera_linea" ? "ub_segunda_linea" : "ub_primera_linea";
    cambiarDirecto(name, !form[name]);
    if (!form[name]) cambiarDirecto(otro, false);
  };

  const labelStyle = {
    fontSize: 11, fontWeight: 600, color: c.textMuted,
    textTransform: "uppercase", letterSpacing: "0.04em",
    marginBottom: 8, display: "block",
  };
  const inputStyle = {
    padding: "7px 10px", border: `1px solid ${c.chipBorder}`,
    borderRadius: 6, fontSize: 12, color: c.textPrimary,
    background: isDark ? '#0a0e16' : '#dceeff', outline: "none",
    boxShadow: isDark ? 'inset 0 3px 6px rgba(0,0,0,0.5), inset 0 1px 3px rgba(0,0,0,0.3)' : 'inset 0 3px 6px rgba(100,140,200,0.18), inset 0 1px 3px rgba(80,120,180,0.13)',
  };

  const chipStyle = (activo) => ({
    padding: "4px 10px", fontSize: 11, fontWeight: 500,
    borderRadius: 6,
    border: `1px solid ${activo ? c.chipActiveBorder : c.chipBorder}`,
    background: activo ? c.chipActiveBg : c.chipBg,
    color: activo ? c.chipActiveText : c.chipText,
    cursor: "pointer", transition: "all 0.15s ease",
    userSelect: "none", lineHeight: "1.4",
  });
  const onEnter = (e, activo) => {
    if (!activo) { e.currentTarget.style.background = c.chipHoverBg; e.currentTarget.style.color = c.chipHoverText; e.currentTarget.style.borderColor = c.chipHoverBorder; }
  };
  const onLeave = (e, activo) => {
    if (!activo) { e.currentTarget.style.background = c.chipBg; e.currentTarget.style.color = c.chipText; e.currentTarget.style.borderColor = c.chipBorder; }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

      {puedeVerPrimeraLineaPlaya && (
      <div>
        <label style={labelStyle}>{tv("Línea de playa")}</label>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          {[
            { name: "ub_primera_linea", label: "1ª Línea de playa" },
            { name: "ub_segunda_linea", label: "2ª Línea de playa" },
          ].map(({ name, label }) => {
            const activo = form[name] || false;
            return (
              <div key={name} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <button type="button"
                  disabled={!puedeModificarPrimeraLineaPlaya}
                  title={!puedeModificarPrimeraLineaPlaya ? "No tienes permiso para modificar este dato" : undefined}
                  onClick={() => handleLinea(name)}
                  style={{ ...chipStyle(activo), cursor: puedeModificarPrimeraLineaPlaya ? "pointer" : "not-allowed", opacity: puedeModificarPrimeraLineaPlaya ? 1 : 0.6 }}
                  onMouseEnter={e => puedeModificarPrimeraLineaPlaya && onEnter(e, activo)}
                  onMouseLeave={e => puedeModificarPrimeraLineaPlaya && onLeave(e, activo)}
                >
                  {tv(label)}
                </button>
                {activo && (
                  <input type="text" name={name + "_obs"} value={form[name + "_obs"] || ""}
                    onChange={cambiar} placeholder={tv("Observaciones...")} disabled={!puedeModificarPrimeraLineaPlaya}
                    style={{ ...inputStyle, minWidth: 150, opacity: puedeModificarPrimeraLineaPlaya ? 1 : 0.6 }} />
                )}
              </div>
            );
          })}
        </div>
      </div>
      )}

      <div style={{ display: "flex", flexWrap: "wrap", gap: 16, alignItems: "flex-end" }}>
        {puedeVerDistanciaMar && (
        <div>
          <label style={labelStyle}>{tv("Distancia al mar")}</label>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            {(() => {
              const activo = form.ub_distancia_mar || false;
              return (
                <>
                  <button type="button"
                    disabled={!puedeModificarDistanciaMar}
                    title={!puedeModificarDistanciaMar ? "No tienes permiso para modificar este dato" : undefined}
                    onClick={() => { if (puedeModificarDistanciaMar) cambiarDirecto("ub_distancia_mar", !activo); }}
                    style={{ ...chipStyle(activo), cursor: puedeModificarDistanciaMar ? "pointer" : "not-allowed", opacity: puedeModificarDistanciaMar ? 1 : 0.6 }}
                    onMouseEnter={e => puedeModificarDistanciaMar && onEnter(e, activo)}
                    onMouseLeave={e => puedeModificarDistanciaMar && onLeave(e, activo)}
                  >
                    {tv("Indicar distancia")}
                  </button>
                  {activo && (
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <input type="text" name="ub_distancia_mar_obs" value={form.ub_distancia_mar_obs || ""}
                        onChange={cambiar} placeholder={tv("metros")} disabled={!puedeModificarDistanciaMar}
                        style={{ ...inputStyle, width: 90, opacity: puedeModificarDistanciaMar ? 1 : 0.6 }} />
                      <span style={{ fontSize: 12, color: c.textMuted }}>m</span>
                    </div>
                  )}
                </>
              );
            })()}
          </div>
        </div>
        )}

        {puedeVerUbiVistas && (
        <div style={{ minWidth: 180 }}>
          <label style={labelStyle}>{tv("Vistas")}</label>
          <MultiSelectAuxVistas
            rows={vistas}
            selectedIds={normalizeVistasIdsFromExtras(form)}
            disabled={!puedeModificarUbiVistas}
            onChange={(ids) => {
              const patch = buildVistasExtrasPatch(ids);
              if (typeof cambiarVarios === "function") cambiarVarios(patch);
              else Object.entries(patch).forEach(([k, v]) => cambiarDirecto(k, v));
            }}
          />
        </div>
        )}
      </div>

      {puedeVerUbiAfectaciones && (
      <div>
        <label style={labelStyle}>{tv("Afectaciones legales")}</label>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {[
            { name: "ub_dpmt", label: "DPMT", conObs: true },
            { name: "ub_serv_transito", label: "Serv. Tránsito", conObs: true },
            { name: "ub_serv_proteccion", label: "Serv. Protección", conObs: true },
            { name: "ub_afectacion_costas", label: "No afectado", conObs: true, exclusive: true },
          ].map(({ name, label, conObs, exclusive }) => {
            const activo = form[name] || false;
            const toggleAfectacion = () => {
              if (!puedeModificarUbiAfectaciones) return;
              const next = !activo;
              if (typeof cambiarVarios === "function") {
                const patch = { [name]: next };
                if (!next && conObs) patch[name + "_obs"] = "";
                if (next && exclusive) {
                  ["ub_dpmt", "ub_serv_transito", "ub_serv_proteccion"].forEach((k) => {
                    patch[k] = false;
                    patch[k + "_obs"] = "";
                  });
                } else if (next && !exclusive) {
                  patch.ub_afectacion_costas = false;
                  patch.ub_afectacion_costas_obs = "";
                }
                cambiarVarios(patch);
              } else {
                cambiarDirecto(name, next);
                if (!next && conObs) cambiarDirecto(name + "_obs", "");
                if (next && exclusive) {
                  ["ub_dpmt", "ub_serv_transito", "ub_serv_proteccion"].forEach((k) => {
                    cambiarDirecto(k, false);
                    cambiarDirecto(k + "_obs", "");
                  });
                } else if (next && !exclusive) {
                  cambiarDirecto("ub_afectacion_costas", false);
                  cambiarDirecto("ub_afectacion_costas_obs", "");
                }
              }
            };
            return (
              <div key={name} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <button type="button"
                  disabled={!puedeModificarUbiAfectaciones}
                  title={!puedeModificarUbiAfectaciones ? "No tienes permiso para modificar este dato" : undefined}
                  onClick={toggleAfectacion}
                  style={{ ...chipStyle(activo), cursor: puedeModificarUbiAfectaciones ? "pointer" : "not-allowed", opacity: puedeModificarUbiAfectaciones ? 1 : 0.6 }}
                  onMouseEnter={e => puedeModificarUbiAfectaciones && onEnter(e, activo)}
                  onMouseLeave={e => puedeModificarUbiAfectaciones && onLeave(e, activo)}
                >
                  {tv(label)}
                </button>
                {activo && conObs && (
                  <input type="text" name={name + "_obs"} value={form[name + "_obs"] || ""}
                    onChange={cambiar} placeholder={tv("Obs.")} disabled={!puedeModificarUbiAfectaciones}
                    style={{ ...inputStyle, width: 130, opacity: puedeModificarUbiAfectaciones ? 1 : 0.6 }} />
                )}
              </div>
            );
          })}
        </div>
      </div>
      )}

      <BotonesVisorUbicacion propiedad={form} addressContext={visorAddressContext} />
    </div>
  );
}
